import { render } from "./DSpinner.vue?vue&type=template&id=1d7e8669"
import script from "./DSpinner.vue?vue&type=script&lang=js"
export * from "./DSpinner.vue?vue&type=script&lang=js"

import "./DSpinner.vue?vue&type=style&index=0&id=1d7e8669&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__